import script from "./ProductToolsBottom.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductToolsBottom.vue?vue&type=script&setup=true&lang=ts"

import "./ProductToolsBottom.scss?vue&type=style&index=0&id=09d5beec&scoped=true&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09d5beec"]])

export default __exports__